// import
import Dashboard from "views/Dashboard/Dashboard.js";
import Tables from "views/Dashboard/Tables.js";
import Orders from "views/Dashboard/Orders.js";
import OrdersPicked from "views/Dashboard/OrdersPicked.js";
import PickingPanel from "views/Dashboard/PickingPanel.js";
import Billing from "views/Dashboard/Billing.js";
import RTLPage from "views/RTL/RTLPage.js";
import Profile from "views/Dashboard/Profile.js";
import SignIn from "views/Pages/SignIn.js";
import SignUp from "views/Pages/SignUp.js";
import SignOut from "views/Pages/SignOut.js";

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
} from "components/Icons/Icons";

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Panel",
    rtlName: "لوحة القيادة",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/pedidos",
    name: "Pedidos",
    rtlName: "لوحة القيادة",
    icon: <StatsIcon color="inherit" />,
    component: Orders,
    layout: "/admin",
  },
  {
    path: "/en-picking",
    name: "En picking",
    rtlName: "لوحة القيادة",
    icon: <CreditIcon color="inherit" />,
    component: OrdersPicked,
    layout: "/admin",
  },
  {
    path: "/pedidos/:code",
    name: "Picking",
    rtlName: "لوحة القيادة",
    icon: <StatsIcon color="inherit" />,
    component: PickingPanel,
    layout: "/admin",
    hide: true,
    hideInHeader: true,
  },
  {
    name: "Mi cuenta",
    category: "account",
    rtlName: "صفحات",
    state: "pageCollapse",
    views: [
      {
        path: "/",
        name: "Perfil",
        rtlName: "لوحة القيادة",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Profile,
        layout: "/admin",
        hide: true,
        hideInHeader: true,
      },
      {
        path: "/signin",
        name: "Ingresar",
        rtlName: "لوحة القيادة",
        icon: <DocumentIcon color="inherit" />,
        secondaryNavbar: true,
        component: SignIn,
        layout: "/auth",
      },
      {
        path: "/signup",
        name: "Registrarse",
        rtlName: "لوحة القيادة",
        icon: <RocketIcon color="inherit" />,
        secondaryNavbar: true,
        component: SignUp,
        layout: "/auth",
      },
      {
        path: "/signout",
        name: "Salir",
        rtlName: "لوحة القيادة",
        icon: <RocketIcon color="inherit" />,
        component: SignOut,
        layout: "/auth",
      },
    ],
  },
];
export default dashRoutes;
